module.exports = __webpack_public_path__ + "static/media/odonklassniki-logo.6ee10116.svg";